// extracted by mini-css-extract-plugin
module.exports = {"tabsContent":"Tabs_tabsContent__31FUq","tabsContainer":"Tabs_tabsContainer__3abmd","buttonContainer":"Tabs_buttonContainer__2WG9s"};